<template>
  <div class="home-container">
    <el-row>
      <el-col :span="16"
              style="padding-right:8px">
        <el-card>
          <div slot="header"
               class="card-header">
            <span>Key 使用情况</span>
          </div>
          <div class="key-body">
            <div>
              已创建的Key
            </div>
            <div style="margin-top:30px">
              <router-link to="/console/key"><span class="show-num">{{keyNum}}</span> 个</router-link>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8"
              style="padding-left:8px">
        <el-card>
          <div slot="header"
               class="card-header">
            <span>账号信息</span>
          </div>
          <div class="user-info">
            <div>
              <span class="label">账号：</span> <span>{{userInfo.name }}</span>
            </div>
            <!-- <div>
              <span class="label">邮箱：</span> <span>{{userInfo.email }}</span>
            </div> -->
            <div>
              <span class="label">手机：</span> <span>{{userInfo.mobile }}</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top:30px">
      <el-col :span="16"
              style="padding-right:8px">
        <el-card>
          <div slot="header"
               class="card-header">
            <span>基础服务使用情况</span>
          </div>
          <div class="service-body">
            <div>
              <div>
                今日调用量超限
              </div>
              <div style="margin-top:30px">
                <router-link to="/console/flowdetail/overrun"><span class="show-num">{{callNum}}</span> 个</router-link>
              </div>
            </div>
            <div>
              <div>
                今日QPS超限
              </div>
              <div style="margin-top:30px">
                <router-link to="/console/flowdetail/overrun">
                  <span class="show-num">{{qpsNum}}</span> 个
                </router-link>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8"
              style="padding-left:8px">
        <el-card>
          <div slot="header"
               class="card-header">
            <span>平台公告</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="goRouter('/notice/announce')">更多>></el-button>
          </div>
          <div class="notice-list">
            <el-row v-for="item in dataList"
                    :key="item.id">
              <el-col :span="24">
                <el-link @click.prevent="goRouterWithId(item.id)">{{
          item.title
        }}</el-link>
              </el-col>

            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import http from '@/http/index.js'

export default {
  data() {
    return {
      keyNum: null,
      qpsNum: null,
      callNum: null,
      userInfo: {
        name: null,
        email: null,
        mobile: null
      },
      dataList: [
        {
          title: '美团地图开放平台上线',
          time: '2021年8月17日',
          id: 0
        }
      ]
    };
  },
  methods: {
    goRouter(path) {
      this.$router.push(path);
    },
    goRouterWithId(id) {
      this.$router.push({ name: 'article', params: { id } });
    }
  },
  async created() {
    let res = await http.key.count();

    this.keyNum = res;

    this.userInfo = this.$store.state.user.userInfo;
    res = await http.key.serviceInfo();
    this.qpsNum = res.qpsOverrun;
    this.callNum = res.doseOverrun;
  }
};
</script>

<style lang="less" scoped>
.el-card {
  height: 300px;
  .card-header {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.84);
    font-weight: 600;
    line-height: 25px;
  }
  .key-body {
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .user-info {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .label {
      margin-right: 15px;
    }
  }
  .service-body {
    height: 200px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
  }
  .notice-list {
    height: 200px;
  }
  .show-num {
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    line-height: 25px;
  }
}
</style>
